import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { usePayslipsVisible } from "@/hooks/useLeaveVisible";

const money = n => `$${Number(n || 0).toLocaleString("en-NZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export async function downloadPayslip(p) {
  const r = await api.get(`/payslips/${p.id}/pdf`, { responseType: "blob" });
  const a = document.createElement("a"); a.href = URL.createObjectURL(r.data);
  a.download = `payslip-${p.worker_name.replace(/ /g, "-")}-${p.pay_date}.pdf`; a.click();
}

export default function WorkerPayslips() {
  const on = usePayslipsVisible();
  const [list, setList] = useState(null);
  useEffect(() => { if (on) api.get("/payslips/mine").then(r => setList(r.data)).catch(() => setList([])); }, [on]);
  if (on === null) return null;
  if (!on) return <div className="card" data-testid="payslips-off">Payslips aren't available in the Hub yet.</div>;
  return (
    <div className="space-y-3 pb-24" data-testid="worker-payslips">
      <h1 className="text-2xl">My payslips</h1>
      {list && list.length === 0 && <div className="card text-sm opacity-60">No payslips yet.</div>}
      {(list || []).map(p => (
        <div key={p.id} className="card flex items-center justify-between gap-2" data-testid={`my-payslip-${p.id}`}>
          <div className="text-sm">
            <div className="font-medium">{fmtDate(p.period_start)} – {fmtDate(p.period_end)}</div>
            <div className="opacity-70">Paid {fmtDate(p.pay_date)} · Net {money(p.totals?.net)}</div>
          </div>
          <button className="btn-silver text-sm px-4 py-2" onClick={() => downloadPayslip(p)} data-testid={`my-payslip-pdf-${p.id}`}>PDF</button>
        </div>
      ))}
    </div>
  );
}
